"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Separator } from "@/components/ui/separator";
export default function TheBenewealthStandard() {
  const intro = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const pillarsBlock = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const pillars = [{
    glyph: "§ 01",
    title: "Architectural Precision",
    body: "We do not simply fix errors; we re-engineer your entire financial profile to meet the rigorous standards of institutional lenders."
  }, {
    glyph: "§ 02",
    title: "Selective Partnership",
    body: "Exclusivity is our foundation. We work only with serious individuals ready to execute high-level wealth strategies."
  }, {
    glyph: "§ 03",
    title: "Capital Velocity",
    body: "Our framework is designed to accelerate your access to funding, turning credit into a high-performance engine for growth."
  }];
  return <section data-section-id="299" id="the-benewealth-standard" className="bg-background text-foreground relative overflow-hidden py-32 md:py-[200px] px-6">
      {}
      <div className="absolute inset-0 bg-cover bg-center opacity-5 pointer-events-none" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695823/img/benewealth_blueprint_texture.png)"
    }} aria-hidden="true" />
      <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695823/img/benewealth_blueprint_texture.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695823/img/benewealth_blueprint_texture.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695823/img/benewealth_blueprint_texture.png-wvc-sizes" alt="" aria-hidden="true" loading="lazy" decoding="async" className="hidden" />

      <div className="relative mx-auto max-w-6xl">
        {}
        <div ref={intro.ref} className={`mx-auto max-w-[760px] text-center transition-all duration-[1200ms] ease-out ${intro.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <p className="font-mono text-xs md:text-sm tracking-[0.2em] uppercase mb-10" style={{
          color: "var(--primary)"
        }}>
            The Benewealth Standard — 
          </p>

          <h2 className="font-default font-serif font-medium text-foreground text-4xl sm:text-5xl md:text-6xl lg:text-[64px] leading-[1.1] tracking-tight">
            The <em className="italic font-medium text-primary">Architecture</em> of Capital.
          </h2>

          <p className="font-default text-foreground/85 text-xl md:text-2xl leading-[1.7] mt-12">
            Financial freedom is not found in a score; it is built through strategy. 
            At Benewealth Financial, we view credit as the blueprint for your 
            economic legacy. We do not arrive with temporary fixes; we arrive 
            with a master plan. We wait for the right data, the right timing, 
            and the right structure to ensure your access to capital is not 
            just possible, but inevitable. What we build is not just a profile, 
            but a pathway to generational wealth.
          </p>
        </div>

        {}
        <div className="flex justify-center mt-20 mb-20 md:mt-24 md:mb-24">
          <Separator className="w-20 h-px" style={{
          backgroundColor: "var(--primary)",
          opacity: 0.6
        }} />
        </div>

        {}
        <div ref={pillarsBlock.ref} className={`grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-16 transition-all duration-[1200ms] ease-out ${pillarsBlock.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          {pillars.map((pillar, i) => <div data-index={i} key={pillar.title} className="flex flex-col items-center text-center">
              <span className="font-mono text-xs md:text-sm mb-6 leading-none font-bold tracking-widest" style={{
            color: "var(--primary)"
          }} aria-hidden="true">
                {pillar.glyph}
              </span>
              <h3 className="font-default italic font-medium text-foreground text-2xl md:text-[26px] leading-snug mb-5">
                {pillar.title}
              </h3>
              <p className="font-default text-foreground/80 text-base leading-[1.7] max-w-xs">
                {pillar.body}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}